import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FormEditorBase } from '../../../../settings-v2/components/form-editor-base';
import { environment } from '../../../../../environments/environment';

export interface PasswordSet {
  currentPassword: string;
  password: string;
  confirmPassword: string;
}

@Component({
  selector: 'townip-password-update-form',
  templateUrl: './password-update-form.component.html',
  styleUrls: ['./password-update-form.component.scss']
})
export class PasswordUpdateFormComponent extends FormEditorBase implements OnInit {
  @Input()
  public tempPassword: string;
  @Input()
  public resetInd = false;
  @Input()
  public askCurrentPassword = true;
  public showError = false;
  public form: UntypedFormGroup;
  private minChars: number;
  private maxChars: number;

  constructor(private fb: UntypedFormBuilder) {
    super();
    this.minChars = environment.minPasswordLength;
    this.maxChars = environment.maxPasswordLength;
  }

  public ngOnInit(): void {
    const oneUpperCaseRegex = /[A-Z]/;
    const oneLowerCaseRegex = /[a-z]/;
    const oneNumberRegex = /\d/;
    const noSpecialCharacter = /^[a-zA-Z0-9]+$/;

    const passwordValidators = [
      Validators.required,
      Validators.minLength(this.minChars),
      Validators.maxLength(this.maxChars),
      Validators.pattern(oneUpperCaseRegex),
      Validators.pattern(oneLowerCaseRegex),
      Validators.pattern(oneNumberRegex),
      Validators.pattern(noSpecialCharacter)
    ];

    // The form for password resets does not show the current password field.
    if (this.resetInd) {
      this.form = this.fb.group({
        password: ['', passwordValidators],
        confirmPassword: ['', Validators.required],
      });
    } else {
      // The form for first time logins with a temp password will not show the current password field.
      this.form = this.fb.group({
        // TODO we may want the same validator here, but our current firebase passwords are no good.
        //  Also the temp passwords could cause issues,
        currentPassword: [this.tempPassword, [Validators.required]],
        password: ['', passwordValidators],
        confirmPassword: ['', Validators.required],
      });
    }

    if (!this.askCurrentPassword) {
      this.form.removeControl('currentPassword', { emitEvent: true });
    }
  }

  public checkPasswordsMatch(): void {
    this.showError = this.form.getRawValue().password !== this.form.getRawValue().confirmPassword;

  }

  public isFormValid(): boolean {
    PasswordUpdateFormComponent.validateForm(this.form);
    if (this.form.getRawValue().password !== this.form.getRawValue().confirmPassword) {
      this.showError = true;
      return false;
    }
    return this.form.valid;
  }

  public getFormValue(): PasswordSet {
    if (this.isFormValid()) {
      const formValue = this.form.getRawValue();
      return formValue;
    } else {
      this.showError = true;
    }
  }
}
